import m from "mithril";

import { Year, getYear } from "../lib/data";
import { DayButton } from "../components/day_button";

type YearPageParams = {
  attrs: { year: string },
};

export class YearPage {
  year: number;
  data: Year;

  constructor({ attrs }: YearPageParams) {
    this.year = parseInt(attrs.year);
    this.data = getYear(this.year);
  }

  view() {
    return(
      <>
        <h1 className="year-title">{this.year}</h1>
        <div className="day-button-container">
          {this.data.days.map(
            (day) => <DayButton year={this.year} day={day.day.toString()} />
          )}
        </div>
      </>
    );
  }
}
